<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-05-25 19:19:46
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-05-22 12:32:09
-->
<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <ActivityCheck />
  </div>
</template>
<script>
import ActivityCheck from "@/components/ActivityCheck";
export default {
  name: "App",
  components: { ActivityCheck },
  mounted() {
    this.$router.onReady(() => {
      if (this.$route.query.flag) {
        localStorage.setItem("om-pc-flag", this.$route.query.flag);
      }
    });
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    this.$store.commit("setActivityCheckVisible", false);
    this.$store.commit("shNoticeShow", false);
  }
};
</script>
<style>
html,
body,
#app {
  padding: 0;
  margin: 0;
  background: #f5f5f5;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue